module.exports = __webpack_public_path__ + "static/media/agente_outbound_inbound_icon.ea562506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/agente_outbound_inbound_icon.svg
// module id = 1780
// module chunks = 0